// Frontend-only view-model types and default-value factories.
//
// All wire types live in @common/contracts (the single source of truth shared
// with the backend). This module re-exports the ones components historically
// imported from here, so it must not re-declare any of them.
import { v4 as uuidv4 } from 'uuid';
import { FaDumbbell, FaRunning, FaEye, FaBrain, FaShieldAlt } from 'react-icons/fa';
import { AvatarAbility, DialogueBackgroundMode, LockStatus, PrizeType, } from '@common/contracts';
export { DialogueBackgroundMode, DialogueRewardLevel, PrizeType, ScannableResourceSelectionType, } from '@common/contracts';
// Helper to get all PrizeType values for dropdowns
export const ALL_PRIZE_TYPES = Object.values(PrizeType);
export const createDefaultNodeData = () => ({
    typeId: null,
    hasScannableResources: false,
    initialLock: LockStatus.Unlocked,
    simpleEvents: [],
    // prizesWithoutTrial is initially undefined
    randomEncounters: {
        enabled: false,
        probability: 10, // 10% by default
        encounterSelection: 'all',
        selectedEncounters: []
    }
});
// Colors for different avatar characteristics
export const ABILITY_COLORS = {
    [AvatarAbility.Strength]: '#F44336', // Red
    [AvatarAbility.Agility]: '#2196F3', // Blue
    [AvatarAbility.Perception]: '#9C27B0', // Purple
    [AvatarAbility.Intellect]: '#4CAF50', // Green
    [AvatarAbility.Defence]: '#FFC107' // Yellow
};
// Icon per avatar characteristic — pairs with ABILITY_COLORS for the trial cards.
export const ABILITY_ICONS = {
    [AvatarAbility.Strength]: FaDumbbell,
    [AvatarAbility.Agility]: FaRunning,
    [AvatarAbility.Perception]: FaEye,
    [AvatarAbility.Intellect]: FaBrain,
    [AvatarAbility.Defence]: FaShieldAlt
};
// Create new event with default values
export const createDefaultEvent = (levelId) => ({
    id: `event_${uuidv4()}`,
    levelId: levelId,
    isEncounter: false,
    title: "New Event",
    description: "Event description",
    encounters: [
        {
            ability: AvatarAbility.Strength,
            difficulty: 5,
            powerCost: 10,
            failurePenalty: 5,
            rewardType: PrizeType.Money,
            rewardAmount: 100,
            successText: "You successfully passed the obstacle!",
            failureText: "You failed the obstacle."
        }
    ]
});
export const createDefaultDialogue = () => {
    const rootNodeId = `node_${uuidv4()}`;
    return {
        id: `dialogue_${uuidv4()}`,
        name: "New Dialogue",
        nodes: [
            {
                id: rootNodeId,
                text: "Hello! This is the start of the dialogue.",
                nodeType: 'npc',
                isRoot: true,
                responseOptions: []
            }
        ],
        rootNodeId: rootNodeId,
        backgroundMode: DialogueBackgroundMode.Map
    };
};
